import Immutable from 'immutable';
import {
  FLAG_GETTING_GENERAL_INCOME_TYPES,
  GET_GENERAL_INCOME_TYPES,
  CLEAR_GENERAL_INCOME_TYPES,
  FLAG_GETTING_GENERAL_INCOME_TYPE,
  GET_GENERAL_INCOME_TYPE,
  CLEAR_GENERAL_INCOME_TYPE
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_GENERAL_INCOME_TYPES:
      return state.setIn(['all', 'loading'], payload);
    case GET_GENERAL_INCOME_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_GENERAL_INCOME_TYPES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GETTING_GENERAL_INCOME_TYPE:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_GENERAL_INCOME_TYPE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_GENERAL_INCOME_TYPE:
            return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
